import { getRouteApi } from "@tanstack/react-router";

const orgRoute = getRouteApi("/_authed/$orgSlug");
const appRoute = getRouteApi("/_authed/$orgSlug/apps/$appSlug");

/** The current organization slug (already authorized by the route loader). */
export function useOrgSlug(): string {
  return orgRoute.useParams().orgSlug;
}

export function useAppParams(): { org: string; app: string } {
  const params = appRoute.useParams();
  return { org: params.orgSlug, app: params.appSlug };
}
